export default __webpack_public_path__ + "static/media/img (1).82dc6cd9.jpg";